/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 17e65e44bb0cb915b1d52562561a2b2a */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NewsQueryVariables = {
    count: number;
    cursor?: string | null;
    tags?: Array<string | null> | null;
};
export type NewsQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"News_viewer">;
    };
};
export type NewsQuery = {
    readonly response: NewsQueryResponse;
    readonly variables: NewsQueryVariables;
};



/*
query NewsQuery(
  $count: Int!
  $cursor: String
  $tags: [String]
) {
  viewer {
    ...News_viewer_3EtMAt
  }
}

fragment BlogPostCard_post on BlogPost {
  title
  publicationDate
  slug
  coverImage
}

fragment News_viewer_3EtMAt on Viewer {
  posts: blogPosts(first: $count, after: $cursor, tags: $tags) {
    edges {
      cursor
      node {
        ...BlogPostCard_post
        id
        __typename
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "tags",
    "type": "[String]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "tags",
  "variableName": "tags"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v1/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "NewsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "News_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "NewsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "posts",
            "name": "blogPosts",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "BlogPostConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BlogPostEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BlogPost",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "publicationDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "coverImage",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "id",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": "posts",
            "name": "blogPosts",
            "args": (v2/*: any*/),
            "handle": "connection",
            "key": "News_posts",
            "filters": [
              "tags"
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "NewsQuery",
    "id": null,
    "text": "query NewsQuery(\n  $count: Int!\n  $cursor: String\n  $tags: [String]\n) {\n  viewer {\n    ...News_viewer_3EtMAt\n  }\n}\n\nfragment BlogPostCard_post on BlogPost {\n  title\n  publicationDate\n  slug\n  coverImage\n}\n\nfragment News_viewer_3EtMAt on Viewer {\n  posts: blogPosts(first: $count, after: $cursor, tags: $tags) {\n    edges {\n      cursor\n      node {\n        ...BlogPostCard_post\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '446bbc5c2fdb022a148d4468e728f9ed';
export default node;
